import { Component } from '@angular/core';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent {
  title = 'Contact';
}



// WEBPACK FOOTER //
// ./src/app/contact.component.ts